import { useMutation } from '@tanstack/react-query'

import { donationApi } from '../api/donationApi'
import type { DONATION_SOURCE } from '../api/types/donation'

export const useDonationBannerDisplayedMutation = () =>
  useMutation({
    mutationFn: (payload: { source?: DONATION_SOURCE }) => donationApi.setDonationBannerDisplayed(payload),
  })
